import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import * as GoogleAnalytics from 'react-ga';

GoogleAnalytics.initialize('UA-119578649-1');
export default function withTracker(WrappedComponent: React.ComponentType, options = {}) {
  const trackPage = (page: string) => {
    GoogleAnalytics.set({
      page,
      ...options
    });
    GoogleAnalytics.pageview(page);
  };

  return class extends React.Component<RouteComponentProps> {
    componentDidMount() {
      const page = this.props.location.pathname;
      trackPage(page);
    }

    componentWillReceiveProps(nextProps: RouteComponentProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}
